const products = [
  {
    id: 1,
    price: 30,
    name: 'Onion',
    img: 'https://media.istockphoto.com/id/503144946/photo/red-onion-with-the-outer-peel-removed.jpg?s=612x612&w=0&k=20&c=Zq7KI5GtxL8Ag2nHkGMOcqzuKBdFlnoHaoTEz1f8iRQ=',
  },
  {
    id: 2,
    price: 20,
    name: 'Potatoes',
    img: 'https://media.istockphoto.com/id/157430678/photo/three-potatoes.jpg?s=612x612&w=0&k=20&c=qkMoEgcj8ZvYbzDYEJEhbQ57v-nmkHS7e88q8dv7TSA=',
  },
  {
    id: 3,
    price: 25,
    name: 'Tomato',
    img: 'https://media.istockphoto.com/id/941825808/photo/tomato-isolated-tomato-on-white-background-with-clipping-path-full-depth-of-field.jpg?s=612x612&w=0&k=20&c=FOo7yfEpxmdTHYBHVr2og-nE_m4mib32rYxZQxUARbs=',
  },
  {
    id: 4,
    price: 90,
    name: 'Chilli',
    img: 'https://media.istockphoto.com/id/538623177/photo/chili-pepper.jpg?s=612x612&w=0&k=20&c=nMO8DC5wBLjgHQ-A5kXDAb62xfpZlUkFJDKzaeIp67s=',
  },
  {
    id: 5,
    price: 80,
    name: 'Garlic',
    img: 'https://media.istockphoto.com/id/499147864/photo/garlic.jpg?b=1&s=170667a&w=0&k=20&c=hwlpUfQr-CFYFrfJtpWM0OAV5DiKFc092VNULCkZA6k=',
  },
  {
    id: 6,
    price: 70,
    name: 'Capsicum',
    img: 'https://cdn.shopify.com/s/files/1/0451/1101/7626/products/greencapsicum.jpg?v=1606107907',
  },
];

export default products;
